<span
  [class]="'text ' + size"
  [ngStyle]="{ color: 'var(--color-' + color + ')', 'font-weight': weight }"
>
  <ng-content></ng-content>
</span>
